import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import Text from '@gojob/ui-bits/Text';
import BreakpointContainer from '../../BreakpointContainer';

export type UpperTextProps = {
  upperText?: string;
};

const UpperText: FunctionComponent<UpperTextProps> = (props) => {
  const { upperText } = props;
  if (!upperText) {
    return null;
  }

  return (
    <Flex width="100%" justifyContent="center">
      <BreakpointContainer maxWidth="md">
        <Text variant="message3" gutter={7} css={{ textAlign: 'center' }}>
          {upperText}
        </Text>
      </BreakpointContainer>
    </Flex>
  );
};

export default UpperText;
